import { useQueryApi } from 'utils/api'
import {
  apiPaths,
  handleError,
  queryKeys,
  validateStatus,
} from 'api/kinerja/penilik-pegawai/config'

import type { UseQueryOptions } from 'react-query'
import type { CommonResponse } from 'types/api'
import type { PenilikPegawaiProfile } from 'types/kinerja-penilik-pegawai'

type ProfileResponse = CommonResponse<PenilikPegawaiProfile>

export function useAPIGetPenilikPegawaiProfile(
  options: UseQueryOptions<ProfileResponse>
) {
  return useQueryApi<ProfileResponse>(apiPaths.profile, {
    queryKey: [queryKeys.API_GET_PROFILE],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
